import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../store/hooks';

interface AdminHeaderProps {
  onLogout: () => void;
  onBack?: () => void;
  title?: string;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onLogout, onBack, title = 'Admin Dashboard' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const role = useAppSelector((state) => state.auth.user?.role);

  const navItems = [
    { label: 'Books',     path: '/admin' },
    { label: 'Users',     path: '/admin/users' },
    { label: 'Outreach',  path: '/admin/outreach' },
    { label: 'Analytics', path: '/admin/analytics' },
    { label: 'Support',   path: '/admin/support' },
    { label: 'Feedback',  path: '/admin/feedback' },
    // Only superadmin can reach the staff-management page — no reason to
    // show admins/sales a link to something they'd immediately be blocked from.
    ...(role === 'superadmin' ? [{ label: 'Staff', path: '/admin/staff' }] : []),
  ];

  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          {onBack && (
            <button
              onClick={onBack}
              className="p-1 text-gray-500 hover:text-gray-900 rounded-md hover:bg-gray-100"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        </div>

        <div className="flex items-center gap-1">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === item.path
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={onLogout}
            className="ml-2 px-4 py-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
